import React from 'react'

import ReportsDemoTable, { ReportsDemoCells, ReportsDemoRow } from 'Pages/ReportsAlerts/Reports/@components/DemoTable'


const DEMO_REPORTS = [
	{
		name: 'Madrid → Barcelona Weekly',
		searches: 216,
		sites: ['rentalspot.demo', 'pricefly.demo'],
		hours: ['08:00', '14:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays'],
		pickup: 'Madrid Airport (MAD)',
		dropoff: 'Barcelona Airport (BCN)',
		date: '10 Feb 2025 08:22',
		status: 'ready',
		enabled: true,
	},
	{
		name: 'London LHR → Manchester MAN',
		searches: 1080,
		sites: ['bookride.demo', 'findwheels.demo', 'autolink.demo'],
		hours: ['06:00', '12:00', '18:00'],
		frequency: ['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays'],
		pickup: 'Heathrow Airport (LHR)',
		dropoff: 'Manchester Airport (MAN)',
		date: null,
		status: 'running',
		progress: 43,
		completeTasks: '464',
		totalTasks: '1080',
		enabled: true,
	},
	{
		name: 'Paris CDG → Nice NCE',
		searches: 144,
		sites: ['rentalspot.demo'],
		hours: ['10:00'],
		frequency: ['Tuesdays', 'Thursdays'],
		pickup: 'Paris CDG Airport (CDG)',
		dropoff: 'Nice Airport (NCE)',
		date: '08 Feb 2025 10:15',
		status: 'ready',
		enabled: true,
	},
	{
		name: 'Rome FCO → Milan MXP',
		searches: 72,
		sites: ['pricefly.demo', 'bookride.demo'],
		hours: ['09:00'],
		frequency: ['Mondays'],
		pickup: 'Rome Fiumicino (FCO)',
		dropoff: 'Milan Malpensa (MXP)',
		date: '03 Feb 2025 09:05',
		status: 'stopped',
		enabled: false,
	},
	{
		name: 'Munich MUC → Frankfurt FRA',
		searches: 432,
		sites: ['rentalspot.demo', 'pricefly.demo', 'findwheels.demo'],
		hours: ['07:00', '13:00', '19:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays', 'Sundays'],
		pickup: 'Munich Airport (MUC)',
		dropoff: 'Frankfurt Airport (FRA)',
		date: '10 Feb 2025 19:08',
		status: 'ready',
		enabled: true,
	},
]

// The quick links each finished report shows under its date
const linksOf = () => ['report', 'export', 'multireport', 'multiexport']

export default function ExtraReportsDemoData() {
	return <ReportsDemoTable title="Reports Extras List" count={DEMO_REPORTS.length}>
		{DEMO_REPORTS.map(r => <ReportsDemoRow key={r.name}>
			<ReportsDemoCells report={r} links={linksOf(r)}/>
		</ReportsDemoRow>)}
	</ReportsDemoTable>
}
